import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import App from './App';
import { msalInstance } from './services/msalConfig';
import './styles/tokens.css';
import './styles/app.css';
import { registerOfflineWorker } from './features/offline/register';

// MSAL must be initialized before render so handleRedirectPromise works on the
// callback route. We render after initialize() resolves.
msalInstance.initialize().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <MsalProvider instance={msalInstance}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MsalProvider>
    </StrictMode>
  );
});

// Offline lessons. Registered AFTER render so a slow or failed registration can
// never delay first paint — and deliberately non-fatal: a browser without
// service workers still gets the whole app, just without downloadable lessons.
registerOfflineWorker();
